<template>
  <div>
    <footer>
        <div class="top_href_a" style="height: 100px;padding-top: 20px;">
          <a style="cursor:context-menu">网站导航：</a>
          <div v-for="(item,index) in butDhList" :key="index" style="display: flex;">
            <a @click="cqym(item)">{{item.title}}</a>
            <div class="divider" v-if="index<(butDhList.length-1)" type="vertical"></div>
          </div>
        </div>
        <img class="gh" src='@/assets/images/footer-gh.png'/>
        <div style="height: 130px;flex-direction: column;padding: 35px;">
          <p>中国·汉阴 版权所有：政协汉阴委员会办公室 陕ICP备2024030805号</p>
          <p>地址：汉阴县城关镇和平街 电话：0915-5212601 投稿邮箱：25178356@qq.com</p>
        </div>
      </footer>
  </div>
</template>

<script>
import { httpAction, getAction } from '@/api/manage'
export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      butDhList:[],
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData(){
      httpAction("/zxwz/zxwzwzdh/page?type=99&pageSize=5&sffb=1&shzt=02",{},'get').then((res)=>{
        if(res.success){
          this.butDhList = res.result.records;
          console.log("99",res.result);
        }else{
          this.$message.warning(res.message);
        }
      })
    },
    cqym(item){
      window.open(item.name);
    }
  },
}
</script>

<style lang="less" scoped>
footer{
  width: 100%;
  height: 200px;
  background: #2966AE;
  position: relative;
  display: flex;
  flex-direction: column;

  .gh{
    width: 56px;
    height: 68px;
    position: absolute;
    bottom: 33px;
    left: 29%;
  }

  .top_href_a{
    width: auto;
    left: 400px;
    top: 0;
    display: flex;

    a{
      margin: auto 20px auto 20px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 16px;
      color: #FFFFFF;
      letter-spacing: 0;
      cursor: pointer;
    }

    .divider{
      width: 1px;
      height: 17px;
      background: #FFFFFF;
      margin: auto;
    }
  }

  >div{
    width: 100%;
    margin: auto;
    box-sizing: border-box;
    display: flex;

    p{
      width: 100%;
      text-align: center;
      font-weight: 400;
      font-size: 16px;
      color: #FFFFFF;
      letter-spacing: 0;
      text-align: center;
      line-height: 26px;

      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 16px;
      color: #FFFFFF;
      letter-spacing: 0;
      text-align: center;
      line-height: 28px;
    }
  }
}
</style>
